import styles from './AnswerButton.module.css';

/**
 * The toggle-like button component for selecting yes/no answers.
 * @param {object} props - The component props
 * @param {string} props.label - The label of the button such as Yes or No
 * @param {boolean} props.isSelected - Whether the current button is selected
 * @param {() => void} props.onSelectAnswer - Callback when the button is clicked
 * @returns {import("react").ReactElement} Answer button component
 */
const AnswerButton = ({ label, isSelected, onSelectAnswer }) => (
  <button
    onClick={onSelectAnswer}
    data-testid='answerButton'
    type='button'
    className={`${styles.button} ${isSelected ? styles.selected : ''}`}
  >
    {label}
  </button>
);

export default AnswerButton;
